(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-oopsibop"]) return;
  try {
    
  (() => {
    if (window.__oopsibopVariantPickerReady) return;
    window.__oopsibopVariantPickerReady = true;

    const money = (cents) => new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'USD',
    }).format((Number(cents) || 0) / 100);

    const updateVariant = (form) => {
      const variantsNode = form.querySelector('[data-product-variants]');
      if (!variantsNode) return;

      let variants = [];
      try { variants = JSON.parse(variantsNode.textContent); } catch (error) { return; }

      const selectedOptions = [...form.querySelectorAll('[data-option-position]')].map((fieldset) => {
        return fieldset.querySelector('[data-option-value]:checked')?.value;
      });
      const variant = variants.find((candidate) => {
        return candidate.options.every((option, index) => option === selectedOptions[index]);
      });

      const idInput = form.querySelector('[data-variant-id]');
      const submit = form.querySelector('[data-variant-submit]');
      const price = form.closest('.oo-product-info')?.querySelector('[data-variant-price]');

      if (!variant) {
        if (idInput) idInput.value = '';
        if (submit) { submit.disabled = true; submit.textContent = 'UNAVAILABLE'; }
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (price) price.textContent = money(variant.price);
      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? `ADD TO BAG — ${money(variant.price)}` : 'SOLD OUT';
      }

      const mediaId = variant.featured_media?.id;
      if (mediaId) {
        const hero = form.closest('.oo-product-hero');
        const thumb = hero?.querySelector(`[data-gallery-thumb][data-media-id="${mediaId}"]`);
        thumb?.click();
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };

    document.addEventListener('change', (event) => {
      if (!event.target.matches('[data-option-value]')) return;
      const form = event.target.closest('[data-variant-form]');
      if (form) updateVariant(form);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
